module.exports = __webpack_public_path__ + "1605fb53904f9a76178216e8db1d1f8b.svg";